import {Dispatch} from 'react';
import {BoxProps, Flex, FlexProps} from '@chakra-ui/react';
import {motion} from 'framer-motion';

import {type Action, type State} from './usePlayersReducer';
import {PlayerSpot} from '../components/playground-lineup';
import {PlayerStatsModal} from '../components/modals';
import type {Player} from '../types';
import {useLineupStore} from './useLineupStore';

type SubstitutesProps = {
  substitutes: [Player | null, Player | null, Player | null, Player | null] | undefined;
  dispatch?: Dispatch<Action>;
  indicatorPosition?: State['indicatorPosition'];
  hasStatsAction?: boolean;
  showPoints?: boolean;
  showStatsModal?: boolean;
} & BoxProps;

export function Substitutes({
  substitutes,
  indicatorPosition,
  dispatch,
  hasStatsAction,
  showStatsModal = true,
  showPoints = true,
  ...props
}: SubstitutesProps) {
  const setPlayerStatsModal = useLineupStore((state) => state.setPlayerStatsModal);

  const onPlayerClick = (player: Player | null) => {
    if (!showStatsModal || !player) return;

    setPlayerStatsModal({context: 'lineup-player', action: 'remove', player});
  };

  return (
    <>
      {substitutes?.map((sub, index) => (
        <PlayerSpot
          key={index}
          player={sub}
          maxW="25%"
          inField={false}
          showPoints={showPoints}
          onClick={() => onPlayerClick(sub)}
          h="max(5.5rem, 4em)"
          {...props}
        />
      ))}

      <PlayerStatsModal hasActions={false} />
    </>
  );
}

const Shimmer = (props: FlexProps) => (
  <Flex gap="2.5" px="2" py="5" bgColor="gray.600" rounded="md" {...props}>
    {Array.from({length: 4}).map((_, i) => (
      <Flex
        key={i}
        as={motion.div}
        flex={1}
        h="5.5rem"
        rounded="md"
        animate={{
          backgroundColor: ['#f3f3f3', '#ecebeb'],
          transition: {duration: 1, repeat: Infinity, repeatType: 'reverse'},
        }}
      />
    ))}
  </Flex>
);

Substitutes.Shimmer = Shimmer;
